import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiPieChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-pie-chart" />;
}
